<template>
	<div>
		<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
			<FormItem prop="trackName" :label="this.$t('Station')" :label-width="100">
				<Select :placeholder="this.$t('Station')" style="width: 200px;" v-model="formInline.StationId">
					<Option :value="0">{{ this.$t('Common.All') }}</Option>
					<Option v-bind:key="item.StationId" v-for="(item) in StationList" :value="item.StationId">
						{{item.StationName}}
					</Option>
				</Select>
			</FormItem>
			<FormItem prop="trackName" :label="this.$t('EquipmentNo')" :label-width="100">
				<Input type="text" v-model="formInline.EquipmentNo" :placeholder="this.$t('EquipmentNo')" />
			</FormItem>
			<FormItem>
				<Button type="primary" @click="handleSubmit('formInline')" v-if="hasWidgets('search')">{{ $t('Common.Search') }}</Button>
			</FormItem>
			<FormItem>
				<Upload :headers="upHeader" name="UpFile" :show-upload-list="false" :on-error="handleError"
					:on-format-error="handleFormatError" :on-success="handleSuccess" :format="['xlsx']"
					:before-upload="beforeUpload" :data='formInline' :action="importDataToEquipmentUrl"
					v-if="hasWidgets('import')">
					<Button icon="ios-cloud-upload-outline">{{ this.$t('BatchImport') }}</Button>
				</Upload>
			</FormItem>
			<div style="float: right;">
				<Button type="primary" @click="show('add')" v-if="hasWidgets('add')">{{ this.$t('Model.Equipment.EquipmentAdd') }}</Button>
				
			</div>
		</Form>
		<Table :columns="columns1" :data="data1" :height="tableHeight"></Table>
		<MyPage ref="sonPage" :param="pageParam" :url="getEquipmentInfoUrl" @listData='getDeviceData'></MyPage>
		<Modal v-model="modalView" :title="modal.Title" width="75%" :mask-closable="false" :closable="false">
			
			<Form label-position="right" :rules="ruleInline"
				v-if="modal.type=='add'||modal.type=='update'||modal.type=='view'" ref="FormItem" :model="FormItem"
				:label-width="150">
				<Row>
					<Col span=7>
					<FormItem :label="this.$t('EquipmentNo')" prop="EquipmentNo">
						<Input :disabled="!ifAddEquipment" v-model="FormItem.EquipmentNo" @on-blur="equipNoChanged" :placeholder="this.$t('EquipmentNo')"></Input>
					</FormItem>
					</Col>
					<Col span=7>
					<FormItem :label="this.$t('Model.Equipment.EquipmentName')" prop="EquipmentName">
						<Input :disabled="ifViewStation" v-model="FormItem.EquipmentName" :placeholder="this.$t('Model.Equipment.EquipmentName')"></Input>
					</FormItem>
					</Col>
					<Col span=7  v-if="false">
					<FormItem :label="this.$t('Model.Equipment.MasterEquipment')" prop="MasterEquipment">
						<Input :disabled="ifViewStation" v-model="FormItem.MasterEquipment"
							:placeholder="this.$t('Model.Equipment.MasterEquipment')"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row>
					<Col span=7>
					<FormItem :label="this.$t('Model.Equipment.EquipmentModel')" prop="EquipmentModel">
						<Select :disabled="ifViewStation" @on-change="modelDefine" :placeholder="this.$t('Model.Equipment.EquipmentModel')"
							v-model="FormItem.EquipmentModel">
							<Option v-bind:key="item.ModelId" v-for="(item) in EquipmentModelDefine"
								:value="item.ModelId">{{item.ModelDesc}}</Option>
						</Select>
					</FormItem>
					</Col>
					<Col span=7>
					<FormItem :label="this.$t('Model.Equipment.EquipmentModel')" prop="EquipmentType">
						<Select :disabled="ifViewStation" :placeholder="this.$t('Model.Equipment.EquipmentModel')" v-model="FormItem.EquipmentType">
							<Option :value="1">{{ 1 | EquipmentTypeDesc }}</Option>
							<Option :value="2">{{ 2 | EquipmentTypeDesc }}</Option>
							<Option :value="3">{{ 3 | EquipmentTypeDesc }}</Option>
							<Option :value="4">{{ 4 | EquipmentTypeDesc }}</Option>
							<Option :value="5">{{ 5 | EquipmentTypeDesc }}</Option>
							<Option :value="255">{{ 255 | EquipmentTypeDesc }}</Option>
						</Select>
					</FormItem>
					</Col>
					<Col span=7>
					<FormItem :label="this.$t('Station')" prop="StationId">
						<Select :disabled="ifViewStation" :placeholder="this.$t('Station')" v-model="FormItem.StationId">
							<Option v-bind:key="item.StationId" v-for="(item) in StationList" :value="item.StationId">
								{{item.StationName}}
							</Option>
						</Select>
					</FormItem>
					</Col>
				</Row>
				<Divider orientation="left"></Divider>
				<Row  v-if="false">
					<Col span=7>
					<FormItem :label="this.$t('Model.Equipment.ManufacturerId')" prop="ManufacturerId">
						<Input :disabled="ifViewStation" v-model="FormItem.ManufacturerId"
							:placeholder="this.$t('Model.Equipment.ManufacturerId')"></Input>
					</FormItem>
					</Col>
					<Col span=7>
					<FormItem :label="this.$t('Model.Equipment.ManufacturerName')" prop="ManufacturerName">
						<Input :disabled="ifViewStation" v-model="FormItem.ManufacturerName"
							:placeholder="this.$t('Model.Equipment.ManufacturerName')"></Input>
					</FormItem>
					</Col>
					<Col span=7>
					<FormItem :label="this.$t('Model.Equipment.ProductionDate')" prop="ProductionDate">
						<Input :disabled="ifViewStation" v-model="FormItem.ProductionDate" :placeholder="this.$t('Model.Equipment.ProductionDate')"></Input>
					
					</FormItem>
					</Col>
				</Row>
				<Row>
					<Col span=7>
					<FormItem :label="this.$t('Model.Equipment.TotolPower')" prop="TotolPower">
						<Input :disabled="ifViewStation" v-model="FormItem.TotolPower" :placeholder="this.$t('Model.Equipment.TotolPower')"></Input>
					</FormItem>
					</Col>
					<Col span=7>
					<FormItem :label="this.$t('Model.Equipment.EquipmentPower')" prop="EquipmentPower">
						<Input :disabled="ifViewStation" v-model="FormItem.EquipmentPower" :placeholder="this.$t('Model.Equipment.EquipmentPower')"></Input>
					</FormItem>
					</Col>
					<Col span=7>
					<FormItem :label="this.$t('Model.Equipment.MinOutputCurrent')" prop="MinOutputCurrent">
						<Input :disabled="ifViewStation" v-model="FormItem.MinOutputCurrent"
							:placeholder="this.$t('Model.Equipment.MinOutputCurrent')"></Input>
					</FormItem>
					</Col>
				
				</Row>
				<Row>
					<Col span=7>
					<FormItem :label="this.$t('Model.Equipment.MaxOutputCurrent')" prop="MaxOutputCurrent">
						<Input :disabled="ifViewStation" v-model="FormItem.MaxOutputCurrent"
							:placeholder="this.$t('Model.Equipment.MaxOutputCurrent')"></Input>
					</FormItem>
					</Col>
					<Col span=7>
					<FormItem :label="this.$t('Model.Equipment.MinOutputVoltage')" prop="MinOutputVoltage">
						<Input :disabled="ifViewStation" v-model="FormItem.MinOutputVoltage"
							:placeholder="this.$t('Model.Equipment.MinOutputVoltage')"></Input>
					</FormItem>
					</Col>
					<Col span=7>
					<FormItem :label="this.$t('Model.Equipment.MaxOutputVoltage')" prop="MaxOutputVoltage">
						<Input :disabled="ifViewStation" v-model="FormItem.MaxOutputVoltage"
							:placeholder="this.$t('Model.Equipment.MaxOutputVoltage')"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row>
					<Col span=7>
					<FormItem :label="this.$t('Model.Equipment.SupportedStandardVersion')" prop="NationalStandard">
						<Select :disabled="ifViewStation" :placeholder="this.$t('Model.Equipment.SupportedStandardVersion')" v-model="FormItem.NationalStandard">
							<Option :value="1">{{ 1 | NationalStandardDesc }}</Option>
							<Option :value="2">{{ 2 | NationalStandardDesc }}</Option>
							<Option :value="3">{{ 3 | NationalStandardDesc }}</Option>
							<Option :value="255">{{ 255 | NationalStandardDesc }}</Option>
						</Select>
					</FormItem>
					</Col>
					<Col span=7>
					<FormItem :label="this.$t('Model.Equipment.AdapteCar')" prop="AdapteCar">
						<Input :disabled="ifViewStation" v-model="FormItem.AdapteCar" :placeholder="this.$t('Model.Equipment.AdapteCar')"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row>
					<Col span=7>
					<FormItem :label="this.$t('Model.Equipment.HardVersion')" prop="HardVersion">
						<Input disabled v-model="FormItem.HardVersion" :placeholder="this.$t('Model.Equipment.HardVersion')"></Input>
					</FormItem>
					</Col>
					<Col span=7>
					<FormItem :label="this.$t('Model.Equipment.Protocol')" prop="Protocol">
						<Input disabled v-model="FormItem.Protocol" :placeholder="this.$t('Model.Equipment.Protocol')"></Input>
					</FormItem>
					</Col>
					<Col span=7>
					<FormItem :label="this.$t('Model.Equipment.ProtocolVersion')" prop="ProtocolVersion">
						<Input disabled v-model="FormItem.ProtocolVersion" :placeholder="this.$t('Model.Equipment.ProtocolVersion')"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row>
	
					<Col span=7>
					<FormItem :label="this.$t('Model.Equipment.SoftVersion')" prop="SoftVersion">
						<Input disabled v-model="FormItem.SoftVersion" :placeholder="this.$t('Model.Equipment.SoftVersion')"></Input>
					</FormItem>
					</Col>
					<Col span=7>
					<FormItem :label="this.$t('Model.Equipment.ProductionBatch')" prop="ProductionBatch">
						<Input :disabled="ifViewStation" v-model="FormItem.ProductionBatch"
							:placeholder="this.$t('Model.Equipment.ProductionBatch')"></Input>
					</FormItem>
					</Col>
					<Col span=7>
					<FormItem :label="this.$t('Model.Equipment.Private')" prop="Private">
						<Select :disabled="ifViewStation" :placeholder="this.$t('Model.Equipment.Private')" v-model="FormItem.Private">
							<Option :value="0">{{ $t('Common.No') }}</Option>
							<Option :value="1">{{ $t('Common.Yes') }}</Option>
						</Select>
					</FormItem>
					</Col>
				</Row>
			</Form>
			<Button type="primary" v-if="modal.type=='add'" @click="addConnector" size="small" shape="circle"
				icon="md-add">{{ $t('Common.Add') }}</Button>
			<Button type="primary" v-if="modal.type=='add'" @click="delConnector" size="small" shape="circle"
				icon="ios-trash">{{ $t('Common.Yes') }}</Button>
			<Table @on-selection-change="ConnectorsSelect" :columns="columns2" :data="FormItem.Connectors"></Table>
			<div v-if="modal.type!='addExcel'" slot="footer">
				<Button type="warning" size="large" @click="modalCancel">{{ $t('Common.Cancel') }}</Button>
				<Button v-if="modal.type=='add' || modal.type=='update'" type="success" size="large"
					@click="modalOk(modal.type)">{{ $t('Common.Confirm') }}</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import dateFormat from '../../../../public/js/comm.js'
	import Qs from 'qs'
	import expandRow from './EquipmentManagementExpand.vue';

    import { formatLocalTime } from "../../../utils/date"
	// import gaodeMap from '../../../js/GaodeMapMethod.js'
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import webapi from '../../../webapi.js';
	export default {
		data() {
			const validateConnertorsNum = (rule, value, callback) => {
				if (value.length == 0) {
					callback(new Error($t('ActionRemind.AddConnectorPlease')));
				} else {
					callback();
				}
			};
			return {
				importDataToEquipmentUrl: webapi.base_api_url + '/Archives/ImportDataToEquipment',
				getEquipmentInfoUrl: webapi.base_api_url + '/Archives/GetEquipmentCarInfo',
				upHeader: {
					'Authorization': "Bearer " + encodeURIComponent(localStorage.AccessToken)
				},
				loadingStatus: false,
				//
				params: "", //
				
				SelectStation: "",
				tableHeight: "650",
				modal: {
					Title: "Add",
					type: "add"
				},
				modalView: false,
				//map modal
				showMap: false,
				center: [114.198595, 22.633595],
				zindex: 1100,
				// Is add?
				ifAddEquipment: true,
				// Is update?
				ifUpdateEquip: false,
				// Is view?
				ifViewStation: false,
			
				connectorDemo: {
					ConnectorTypeDesc: "",
					BmsPowerTypeDesc: "",
					PriceInfo: {
						Id: 0,
						Name: "",
						Period1BeginTime: "00:00",
						Period1EndTime: "00:00",
						Period1Price: 0,
						Period1ServicePrice: 0,
						Period2BeginTime: "00:00",
						Period2EndTime: "00:00",
						Period2Price: 0,
						Period2ServicePrice: 0,
						Period3BeginTime: "00:00",
						Period3EndTime: "00:00",
						Period3Price: 0,
						Period3ServicePrice: 0,
						Period4BeginTime: "00:00",
						Period4EndTime: "00:00",
						Period4Price: 0,
						Period4ServicePrice: 0,
						Period5BeginTime: "00:00",
						Period5EndTime: "00:00",
						Period5Price: 0,
						Period5ServicePrice: 0,
						Period6BeginTime: "00:00",
						Period6EndTime: "00:00",
						Period6Price: 0,
						Period6ServicePrice: 0,
						Period7BeginTime: "00:00",
						Period7EndTime: "00:00",
						Period7Price: 0,
						Period7ServicePrice: 0,
						Period8BeginTime: "00:00",
						Period8EndTime: "00:00",
						Period8Price: 0,
						Period8ServicePrice: 0,
						Period9BeginTime: "00:00",
						Period9EndTime: "00:00",
						Period9Price: 0,
						Period9ServicePrice: 0,
						Period10BeginTime: "00:00",
						Period10EndTime: "00:00",
						Period10Price: 0,
						Period10ServicePrice: 0,
						Period11BeginTime: "00:00",
						Period11EndTime: "00:00",
						Period11Price: 0,
						Period11ServicePrice: 0,
						Period12BeginTime: "00:00",
						Period12EndTime: "00:00",
						Period12Price: 0,
						Period12ServicePrice: 0,
						ServicePrice: 0,
						ModifyTime: "",
						ModifyBy: 0,
						PriceType: 0,
						Previous: 0
					},
					ConnectorNo: "",
					ConnectorName: "",
					ConnectorType: 3,
					Remarks: "",
					VoltageLowerLimits: 0,
					VoltageUpperLimits: 0,
					Power: 0,
					Voltage: 0,
					Current: 0,
					BmsPowerType: 1,
					PriceId: 1,
					Index: 0,
					EquipmentNo: "",
					ParkNo: "",
					QrCode: ""
				},
			
				ConnectorNoDemo: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R",
					"S", "T", "U", "V", "W", "X", "Y", "Z"
				],
				
				ConnectorCache: [],
			
				FormItem: {
					Connectors: [],
					EquipmentTypeDesc: "",
					EquipmentStatusDesc: "",
					NationalStandardDesc: "",
					StationName: "",
					Creator: "",
					Modifier: "",
					EquipmentNo: "",
					EquipmentName: "",
					MasterEquipment: "",
					EquipmentType: 1,
					EquipmentModel: "",
					ManufacturerId: "",
					ManufacturerName: "",
					ProductionDate: "",
					ProductionBatch: "",
					SoftVersion: "",
					HardVersion: "",
					EquipmentLng: 0,
					EquipmentLat: 0,
					TotolPower: 0,
					EquipmentPower: 0,
					EquipmentStatus: 1,
					NationalStandard: 2,
					AdapteCar: "",
					StationId: '',
					HeartbeatPeriod: 0,
					
					CreatedTime: dateFormat.formatDate(new Date(), 'yyyy-MM-dd'),
					CreateBy: 0,
					ModifyTime: dateFormat.formatDate(new Date(), 'yyyy-MM-dd'),
					ModifyBy: 0,
					BarCode: "",
					QrCode: "",
					Ip: "",
					MinOutputCurrent: 0.000000,
					MaxOutputCurrent: 0.000000,
					MinOutputVoltage: 0.000000,
					MaxOutputVoltage: 0.000000,
					SoftName: "",
					Protocol: "",
					ProtocolVersion: "",
					Private: 0,
					Index: 0,
					IsEdit: false
				},
				// Validate Fields
				ruleInline: {
					Connectors: [{
						validator: validateConnertorsNum,
						trigger: 'blur',
					}],
					EquipmentNo: [{
						required: true,
						message: this.$t('EquipmentNo'),
						trigger: 'blur'
					}],
					
					EquipmentType: [{
						required: true,
						message: this.$t('EquipmentType'),
						trigger: 'blur',
						type: 'number'
					}],
					StationId: [{
						required: true,
						message: this.$t('Station'),
						trigger: 'change',
						type: 'number'
					}],
					EquipmentModel: [{
						required: true,
						message: this.$t('Model.Equipment.EquipmentModelTemplate') ,
						trigger: 'change',
					}]
				},
		
				selectModel: [],
				BreadcrumbList: [this.$t('Top.stationManage'), '>>', this.$t('equipmentManage')],
				formInline: {
					StationId: 0,
					EquipmentNo: ''
				},
				columns2: [{
						title:this.$t('ConnectorNo') ,
						key: 'ConnectorNo',
						minWidth: 100,
					}, {
						title: this.$t('ConnectorName') ,
						key: 'ConnectorName',
						width: 100,
						render: (h, params) => {
						
							if (this.ifViewStation) {
								return h('div', params.row[params.column.key])
							}
							return h('Input', this.tableCellEditor(this, params, 80))
						}
					},
					{
						title:  this.$t('ConnectorType'),
						key: 'ConnectorType',
						width: 150,
						render: (h, params) => {
							if (this.ifViewStation) {
								return h('div', params.row.ConnectorTypeDesc)
							}
							const _this = this
							return h('Select', {
								props: {
									value: params.row.ConnectorType,
									transfer: true
								},
								on: {
									'on-change': value => {
										_this.FormItem.Connectors[params.index].ConnectorType = value;
									}
								}
							}, [
								_this.ConnectorTypeList.map((item) => { 
									return h('Option', {
											props: {
												value: item.id,
											}
										},
										item.Status
									)
								})
							])
						}
					},
					{
						title: this.$t('Model.Equipment.VoltageLowerLimits') ,
						key: 'VoltageLowerLimits',
						render: (h, params) => {
							if (this.ifViewStation) {
								return h('div', params.row[params.column.key])
							}
							return h('Input', this.tableCellEditor(this, params, 45))
						}
					},
					{
						title: this.$t('Model.Equipment.VoltageUpperLimits'),
						key: 'VoltageUpperLimits',
						render: (h, params) => {
							if (this.ifViewStation) {
								return h('div', params.row[params.column.key])
							}
							return h('Input', this.tableCellEditor(this, params, 45))
						}
					},
					{
						title: this.$t('Model.Equipment.Power') ,
						key: 'Power',
						render: (h, params) => {
							if (this.ifViewStation) {
								return h('div', params.row[params.column.key])
							}
							return h('Input', this.tableCellEditor(this, params, 45))
						}
					},
					{
						title: this.$t('Model.Equipment.Voltage'),
						key: 'Voltage',
						render: (h, params) => {
							if (this.ifViewStation) {
								return h('div', params.row[params.column.key])
							}
							return h('Input', this.tableCellEditor(this, params, 45))
						}
					},
					{
						title: this.$t('Model.Equipment.Current') ,
						key: 'Current',
						render: (h, params) => {
							if (this.ifViewStation) {
								return h('div', params.row[params.column.key])
							}
							return h('Input', this.tableCellEditor(this, params, 45))
						}
					},
					
					{
						title:  this.$t('Model.Equipment.BmsPowerType'),
						key: 'BmsPowerType',
						width: 110,
						render: (h, params) => {
							if (this.ifViewStation) {
								return h('div', params.row.BmsPowerTypeDesc);
							}
							const _this = this;
							return h('Select', {
								props: {
									value: params.row.BmsPowerType,
									transfer: true
								},
								on: {
									'on-change': value => {
										_this.FormItem.Connectors[params.index].BmsPowerType = value;
									}
								}
							}, [
								_this.BmsPowerTypeList.map((item) => { 
									return h('Option', {
											props: {
												value: item.id,
											}
										},
										item.text
									)
								})
							]);
						}
					},
					
					{
						title: this.$t('Model.Equipment.ParkNo'),
						key: 'ParkNo',
						render: (h, params) => {
							console.log('params: ', params, params.row[params.column.key])
							const _this = this
							if (this.ifViewStation) {
								return h('div', params.row[params.column.key])
							}
							return h('Input', this.tableCellEditor(this, params, 45))
							
						}
					},
					{
						title: this.$t('Model.Equipment.Remarks'),
						key: 'Remarks',
						render: (h, params) => {
							if (this.ifViewStation) {
								return h('div', params.row.Remarks)
							}
							const _this = this
							return h('Input', {
								style: {
									width: '50px'
								},
								props: {
									clearable: true,
									type: 'text',
									value: params.row.Remarks
								},
								on: {
									'on-blur': event => {
										_this.FormItem.Connectors[params.index].Remarks = event.target
											.value;
									}
								}
							})
						}
					},
				],
				//Table Title Data
				columns1: [{
						type: 'expand',
						width: 30,
						render: (h, params) => {
							return h(expandRow, {
								props: {
									row: params.row
								}
							})
						}
					}, {
						title: this.$t('EquipmentNo'),
						key: 'EquipmentNo',
						width: 150,
					}, {
						title: this.$t('Model.Equipment.EquipmentName'),
						key: 'EquipmentName',
						width: 100,
					}
					// , {
					// 	title: this.$t('Model.Equipment.MasterEquipment'),
					// 	key: 'MasterEquipment',
					// 	width: 130,
					// }
					,
					{
						title: this.$t('Model.Equipment.EquipmentType'),
						key: 'EquipmentType',
						width: 120,
						render: (h, params) => {
							return h('div', this.$options.filters.EquipmentTypeDesc(params.row.EquipmentType))
						}
					},
					{
						title: this.$t('StationManagement.ConnectorQuantity'),
						key: 'CreateBy',
						render: (h, params) => {
							return h('div', params.row.Connectors.length)
						},
						width: 100,
					},
					{
						title: this.$t('Model.Equipment.EquipmentModel'),
						key: 'EquipmentModel',
						width: 120
					},
					{
						title: this.$t('Model.Equipment.ManufacturerName'),
						key: 'ManufacturerName',
						width: 200
					},
					{
						title: this.$t('Model.Equipment.RatedPower'),
						key: 'EquipmentPower',
						width: 100
					},
					{
						title: this.$t('Station'),
						key: 'StationId',
						width: 200,
						render: (h, params) => {
							return h('div', params.row.StationName)
						}
					},
					{
						title: this.$t('Model.Equipment.EquipmentStatus'),
						key:  'EquipmentStatusDesc',
						width: 100,
						render: (h, params) => {
							return h('div', this.$options.filters.EquipmentStatusDesc(params.row.EquipmentStatus))
						}
					},
					{
						title: this.$t('Common.CreateTime'),
						key: 'CreatedTime',
						width: 245,
						render: (h, params) => {
							return h('div', formatLocalTime(params.row.CreatedTime))
						}
					},
					{
						title: this.$t('Common.Actions'),
						key: 'action',
						width: 230,
						align: 'center',
					
						render: (h, params) => {
							return h('div', [
								this.hasWidgets('edit') ? h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										click: () => {
											this.show("update", params.row)
										}
									}
								}, this.$t('Common.Edit')) : h(),
								this.hasWidgets('view') ? h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										click: () => {
											this.show("view", params.row)
										}
									}
								}, this.$t('Common.View')) : h(),
								this.methodList.filter(item => this.hasWidgets(item.name)).length > 0 ? h(
									'Dropdown', {
										on: {
											//To avoid incorrect operations, confirm and cancel should function oppositely.
											'on-click': (name) => {
												this.$Modal.confirm({
													title: name,
													okText: this.$t('Common.Cancel'),
													cancelText: this.$t('Common.Confirm'),
													onCancel: () => {
														this.otherMethod(name, params.row
															.EquipmentNo);
													}
												});
												// this.show("deleteStation", params.row.Id)
											}
										}
									},
									[
										h('Button', {
											props: {
												type: 'primary',
												size: 'small',
											},
											style: {
												marginRight: '5px'
											},
										}, this.$t('Common.OtherActions')),
										h('DropdownMenu', {
											slot: 'list'
										}, [
											this.methodList.filter(item => this.hasWidgets(item.name))
											.map((
												item) => { 
												return h('DropdownItem', {
														props: {
															name: item.Status
														}
													},
													item.Status
												)
											})
										])
									],
								) : h()
							]);
						}
					}
				],
				data1: [],
				methodList: [{
						id: 1,
						name: 'building',
						Status: this.$options.filters.EquipmentStatusDesc(1) 
					}, {
						id: 5,
						name: 'swithcOff',
						Status: this.$options.filters.EquipmentStatusDesc(5) 
					},
					{
						id: 6,
						name: 'maintaining',
						Status: this.$options.filters.EquipmentStatusDesc(6) 
					},
					{
						id: 50,
						name: 'running',
						Status: this.$options.filters.EquipmentStatusDesc(50) 
					}
				],
				ConnectorTypeList: [{
						id: 1,
						Status:  this.$options.filters.ConnectorTypeDesc(1)
					}, {
						id: 2,
						Status: this.$options.filters.ConnectorTypeDesc(2)
					},
					{
						id: 3,
						Status: this.$options.filters.ConnectorTypeDesc(3)
					},
					{
						id: 4,
						Status: this.$options.filters.ConnectorTypeDesc(4)
					}, 
					{
						id: 5,
						Status: this.$options.filters.ConnectorTypeDesc(5)
					}, 
					{
						id: 6,
						Status: this.$options.filters.ConnectorTypeDesc(6)
					}, 
					{
						id: 255,
						Status: this.$options.filters.ConnectorTypeDesc(255)
					}
				],
				BmsPowerTypeList: [{
					id: 1,
					text: '12V',
				}, {
					id: 2,
					text: '24V',
				}, {
					id: 3,
					text: this.$t('Model.Equipment.Adaptive') 
				}, {
					id: 255,
					text: this.$t('Other') ,
				}],
			};
		},
		created() {
			const _this = this;
			_this.tableHeight = window.innerHeight - 220;
			window.addEventListener('resize', this.getTableHeight)
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			const operateColumnWidth = Math.max(60, (36 + (this.hasWidgets('edit') ? 60 : 0) + (this.hasWidgets('view') ?
					60 : 0) +
				(this.methodList.filter(item => this.hasWidgets(item.name)).length > 0 ? 80 : 0)));
			//this.columns1.at(-1).minWidth = operateColumnWidth;
			this.handleSubmit();
		},
		computed: {
			pageParam: function() {
				const _this = this;
				const param = {
					StationId: _this.formInline.StationId,
					EquipmentNo: _this.formInline.EquipmentNo
				}
				return param
			},
		
			...mapState({
				StationList: 'Stations',
				EquipmentModelDefine: 'EquipmentModelDefine'
			})
		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			//设备添加预设值
			modelDefine: function(modelValue) {
				const _this = this
				console.log("1111111111111")
				if (modelValue != undefined) {
					console.log("2222222222222")
					_this.selectModel = _this.EquipmentModelDefine.filter(function(model) {
						return model.ModelId == modelValue
					});
					for (let var1 in _this.FormItem) {
						if (_this.selectModel[0].Equipment[var1] != undefined) {
							_this.FormItem[var1] = _this.selectModel[0].Equipment[var1]
						}
					}
					if (_this.FormItem.EquipmentNo != '') {
						const _this = this
						_this.FormItem.Connectors = [];
						for (let i = 0; i < _this.selectModel[0].ConnectorNum; i++) {
							_this.addConnector()
						}
					}
				}
			},
			equipNoChanged: function() {
				const _this = this
				if (!_this.FormItem.EquipmentModel) return;
				
				_this.FormItem.Connectors = [];
				for (let i = 0; i < _this.selectModel[0].ConnectorNum; i++) {
					_this.addConnector()
				}
			},
			//点击自动添加电枪
			addConnector: function() {
				const _this = this
				if (_this.FormItem.EquipmentNo == "") {
					_this.$Message.info(this.$t('ActionRemind.AddEquipmentNo'));
				} else if (_this.selectModel.length == 0) {
					_this.$Message.info(this.$t('ActionRemind.AddEquipmentModel'));
				} else {
					for (let var1 in _this.connectorDemo) {
						console.log(var1)
						// let item = "Connector" + var1;
						let item = var1;
						console.log(_this.selectModel[0].Connector[item])
						if (_this.selectModel[0].Connector[item] != undefined) {
							_this.connectorDemo[var1] = _this.selectModel[0].Connector[item]
							// _this.connectorDemo[var1].ConnectorType = _this.FormItem.EquipmentType == 2 ? 3 : 4;
						}
					}
					_this.connectorDemo.ConnectorNo = _this.FormItem.EquipmentNo + _this.ConnectorNoDemo[_this.FormItem
						.Connectors.length] + '/' + (_this.FormItem.Connectors.length + 1).toString().padStart(2, '0');
					// _this.connectorDemo.ConnectorType = _this.FormItem.ConnectorType;
					// _this.FormItem.Connectors.forEach(function(item, index) {
					// 	if (item.ConnectorNo == _this.connectorDemo.ConnectorNo) {
					// 		_this.connectorDemo.ConnectorNo = _this.connectorDemo.ConnectorNo + '1'
					// 	}
					// })
					_this.FormItem.Connectors.push({
						..._this.connectorDemo
					})
				}
			},
			//选中的枪加入缓存
			ConnectorsSelect: function(Connectors) {
				this.ConnectorCache = Connectors
			},
			//删除选中电枪
			delConnector: function() {
				const _this = this
				_this.FormItem.Connectors.pop();
				
			},
			//Except for delete and modify operations
			otherMethod: function(name, Id) {
				let typeNum = (this.methodList.filter(function(item, index, arr) {
					return item.Status == name
				})[0]).id
				console.log(typeNum)
				this.$axios.post(webapi.base_api_url + "/Archives/SetEquipmentStatus", {
					Id: Id,
					Status: typeNum
				}).then(res => {
					if (res.data.Code == 0) {
						this.$Message.success(name + this.$t('Common.Success'));
						this.$refs.sonPage.getList();
					}
				})
			},

			
			show: function(type, rowInfo) {
				this.ifAddEquipment = false;
				this.ifViewStation = false;
				this.ifUpdateEquip = true;
				switch (type) {
					case "add":
						this.modal.type = "add";
						this.modal.Title = this.$t('ModelInfo.Add');
						this.ifAddEquipment = true
						this.$refs.FormItem.resetFields();
						this.selectModel = []
						this.FormItem = {
							Connectors: [],
							EquipmentTypeDesc: "",
							EquipmentStatusDesc: "",
							NationalStandardDesc: "",
							StationName: "",
							Creator: "",
							Modifier: "",
							EquipmentNo: "",
							EquipmentName: "",
							MasterEquipment: "",
							EquipmentType: 1,
							EquipmentModel: "",
							ManufacturerId: "",
							ManufacturerName: "",
							ProductionDate: "",
							ProductionBatch: "",
							SoftVersion: "",
							HardVersion: "",
							EquipmentLng: 0,
							EquipmentLat: 0,
							TotolPower: 0,
							EquipmentPower: 0,
							EquipmentStatus: 50,
							NationalStandard: 2,
							AdapteCar: "",
							StationId: '',
							HeartbeatPeriod: 0,
						
							CreatedTime: dateFormat.formatDate(new Date(), 'yyyy-MM-dd'),
							CreateBy: 0,
							ModifyTime: dateFormat.formatDate(new Date(), 'yyyy-MM-dd'),
							ModifyBy: 0,
							BarCode: "",
							QrCode: "",
							Ip: "",
							MinOutputCurrent: 0.000000,
							MaxOutputCurrent: 0.000000,
							MinOutputVoltage: 0.000000,
							MaxOutputVoltage: 0.000000,
							SoftName: "",
							Protocol: "",
							ProtocolVersion: "",
							Private: 0,
							Index: 0,
							IsEdit: false
						}
						break;
					case "update":
						this.modal.type = "update";
						this.modal.Title = this.$t('ModelInfo.Edit');
						this.getUpdateMessage(rowInfo);
						this.ifUpdateEquip = true;
						//this.ifViewStation=false
						break;
					case "view":
						this.modal.type = "view";
						this.modal.Title = this.$t('ModelInfo.View');
						this.getUpdateMessage(rowInfo);
						this.ifViewStation = true
						break;
				}
				this.modalView = true;
			},
			tableCellEditor(_this, params, width) {
				return {
					style: {
						width: width + 'px'
					},
					props: {
						clearable: false,
						type: 'text',
						value: params.row[params.column.key]
					},
					on: {
						'on-blur': event => {
							// params.row[params.column.key] = event.target.value
							_this.FormItem.Connectors[params.index][params.column.key] = event.target.value
						}
					}
				}
			},
			getDeviceData: function(data) {
				this.data1 = data.Data.List
			},
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				this.$refs.sonPage.getList();
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 220;
			},
			modalCancel: function() {
				if (this.modal.type === "install") {
					//this.$refs.InstallForm.resetFields();
				} else if (this.modal.type === "add" || this.modal.type === "update" || this.modal.type === "view") {
					this.$refs.FormItem.resetFields();
					this.FormItem.Connectors = [];
					this.modalView = false
				}
			},
			deepClone(params) {
				// 如果数组类型数据
				if (Array.isArray(params)) {
					let newnew = []
					for (let i = 0; i < params.length; i++) {
						newnew[i] = this.deepClone(params[i]) // 递归调用克隆
					}
					return newnew // 克隆完以后，再返回出结果
				}
				// 如果是对象类型数据
				if (Object.prototype.toString.call(params) === '[object Object]') {
					let newnew = {}
					for (const key in params) {
						newnew[key] = this.deepClone(params[key]) // 递归调用克隆
					}
					return newnew // 克隆完以后，再返回出结果
				}
				// 如果是普通数据类型
				return params
			},
			getUpdateMessage: function(equipInfo) {
				console.log(equipInfo);
				const _this = this;
				_this.FormItem = {};
				_this.FormItem = _this.deepClone(equipInfo);
				// for (let i = 0; i < _this.data1.length; i++) {
				// 	if (_this.data1[i].EquipmentNo == EquipmentNo) {
				// 		_this.FormItem = Object.assign({}, _this.data1[i])
				// 	}
				// }
				//_this.modelDefine(_this.FormItem.EquipmentModel)
			},
			modalOk: function(type) {
				const _this = this
				switch (type) {
					case "add":
						_this.FormItem.IsEdit = false
						break;
					case "update":
						_this.FormItem.IsEdit = true
						break;
				}
				//没定必填项
				_this.$refs.FormItem.validate((valid) => {
					console.log("Equipment " + type + "----" + valid)
					if (valid) {
						const param = _this.FormItem
						_this.$axios.post(webapi.base_api_url + '/Archives/AddEquipment',
							param
						).then(res => {
							console.log(res)
							if (res.data.Code == 0) {
								_this.$Message.success(this.$t('Model.Equipment.Equipment') + type +this.$t('Common.Success'));
								_this.$refs.sonPage.getList();
								this.modalView = false;
							} else {
								_this.$Message.error({content: this.$t('Model.Equipment.Equipment') + type + this.$t('Common.Failed')+":" + res.data.Data});
							}
						})
					}
				})
			},
			mapOpen: function() {
				this.showMap = true;
				// gaodeMap.initMap("map", 10, this.center, 'normal');
				// gaodeMap.mapOn(this);
			},
			closeMap: function() {
				// gaodeMap.map.destroy();
				// gaodeMap.map = '';
				this.showMap = false;
			},
			beforeUpload(file) {
				const _this = this
				if (_this.formInline.StationId != 0) {
					let stationName = ''
					_this.StationList.forEach(function(item) {
						console.log(item);
						if (item.StationId == _this.formInline.StationId) {
							stationName = item.StationName
						}
					})
					let p = new Promise(function(resolve, reject) {
						_this.$Modal.confirm({
							title: this.$t('ActionRemind.EquipmentStationAdd')+ "-->" + stationName,
							okText: this.$t('Common.Cancel'),
							cancelText: this.$t('Common.Confirm'),
							onCancel: () => {
								resolve()
							},
							onOk: () => {
								reject()
							}
						});
					})
					return p
				} else {
					this.$Message.info(this.$t('ActionRemind.SelectStation')+"!");
					return false
				}
			},
			handleFormatError(file) {
				this.$Notice.warning({
					title: this.$t('ActionRemind.IncorrectFileFormat') ,
					desc: this.$t('Common.File') +':'+ file.name + this.$t('ActionRemind.UploadXlsxFormat') 
				});
			},
			handleSuccess(res, file) {
				this.$Message.success(this.$t('ActionRemind.ImportResult')+"：" + res.Msg + "---" + res.Data);
				this.handleSubmit()
			},
			handleError(error, file) {
				this.$Message.error(this.$t('ActionRemind.ImportFail'));
			},
		},
	}
</script>

<style>
	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */

	.ivu-tag-dot {
		border: 0px solid #e8eaec !important;
	}

	.ivu-form-item {
		margin-bottom: 10px;
	}
</style>
